module.exports = __webpack_public_path__ + "07b18828863c32aca3fd41125f48dcc8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-3.png
// module id = 3679
// module chunks = 0